import { ActionTree } from "vuex";
import { HistoricActionsTypes, HistoricMutationsTypes } from "./types";
import { Historic, HistoricActions, HistoricState } from "./interface";
import Client from "@/plugins/axios/axios";

export const actions: ActionTree<HistoricState, HistoricState> & HistoricActions = {
  [HistoricActionsTypes.LIST_HISTORIC]: async ({ commit }): Promise<void> => {
    return Client.get(`state/list`).then((response) => {
      commit(HistoricMutationsTypes.SET_HISTORIC, response.data?.body as Array<Historic>)
    });
  }
};
